export default function makeOnStartTyping() {
  var columnTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var store = arguments.length > 1 ? arguments[1] : undefined;
  return {
    onStartTyping: function onStartTyping(event, database, next) {
      var _database$getActive = database.getActive(),
          record = _database$getActive.record,
          column = _database$getActive.column;

      if (!columnTypes.includes(column.type)) {
        return next();
      } // Ensure default focus behavior


      next();
      var fieldKey = database.getFieldKey(record.key, column.key);
      store.updateItem(fieldKey, {
        initialValue: event.key.length === 1 ? event.key : ''
      });
    }
  };
}